<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import { mapGetters,mapActions,mapState } from "vuex"
import moment from "moment";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Production Batch Details",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
  },
  data() {
    return {
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      title: "Production Batch Details",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Production Batch Details",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      filteredData:[],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/No",
        },
        {
          key: "item.name",
          sortable: true,
          label: "ITEM",
        },        
        {
          key: "qty",
          sortable: true,
          label: "QUANTITY",
        },
        {
          key: "unit.name",
          sortable: true,
          label: "UNIT OF MEASURE",
        },
        {
          key: "unit_price",
          sortable: true,
          label: "UNIT PRICE",
        },
        {
          key: "total_price",
          sortable: true,
          label: "TOTAL",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "user.name",
          sortable: true,
          label: "RECORDED BY",
        },
        {
          key: "addedOn",
          sortable: true,
          label: "RECORDED ON",
        }
      ],
      fields1: [
        {
          key: "index",
          sortable: true,
          label: "S/No",
        },
        {
          key: "item.name",
          sortable: true,
          label: "ITEM",
        },        
        {
          key: "qty",
          sortable: true,
          label: "QUANTITY",
        },
        {
          key: "unit.name",
          sortable: true,
          label: "UNIT OF MEASURE",
        },
        {
          key: "unit_price",
          sortable: true,
          label: "UNIT PRICE",
        },
        {
          key: "total_price",
          sortable: true,
          label: "TOTAL",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "user.name",
          sortable: true,
          label: "RECORDED BY",
        },
        {
          key: "branch.name",
          sortable: true,
          label: "BRANCH",
        },
        {
          key: "addedOn",
          sortable: true,
          label: "RECORDED ON",
        }
      ],
      json_fields: {
        ITEM: "item.name",        
        QUANTITY: "qty",
        UNIT_OF_MEASURE: "unit.name",
        UNIT_PRICE: "unit_price",
        TOTAL: "total_price",
        DATE: "date",
        RECORDED_BY: "user.name",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],

    };
  },
  computed: {
         // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
      ]),
    ...mapGetters("production", ["BatchDetails"]),
    ...mapGetters("auth", ["branchid","Branches"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.BatchDetails ? this.BatchDetails.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.BatchDetails ? this.BatchDetails.length : 1;
  },
  methods: {
    ...mapActions({
      FetchConsumableStock: "production/fetchBatchDetails",

    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/\D/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
  },
  created() {
    this.FetchConsumableStock(atob(this.$route.params.id));
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h3 class="card-title mb-2 text-center" v-html="title"></h3>
              </div>
              <div class="col-md-3" align="right">
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="BatchDetails?BatchDetails:[]"
                  :fields="branchid==0?fields1:fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
              </b-table>
            </div>
            <Loader  v-if="!BatchDetails"/>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>
